import { render, staticRenderFns } from "./OfferWebPushCard.vue?vue&type=template&id=74d46377&scoped=true"
import script from "./OfferWebPushCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./OfferWebPushCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OfferWebPushCard.vue?vue&type=style&index=0&id=74d46377&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d46377",
  null
  
)

export default component.exports